var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTables({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      zoom: 0.9
    },
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 7V17M1 12H17M1 7H17M3.84444 17H14.1556C15.1512 17 15.6491 17 16.0293 16.782C16.3638 16.5903 16.6358 16.2843 16.8062 15.908C17 15.4802 17 14.9201 17 13.8V4.2C17 3.0799 17 2.51984 16.8062 2.09202C16.6358 1.71569 16.3638 1.40973 16.0293 1.21799C15.6491 1 15.1512 1 14.1556 1H3.84444C2.8488 1 2.35097 1 1.97068 1.21799C1.63617 1.40973 1.3642 1.71569 1.19377 2.09202C1 2.51984 1 3.07989 1 4.2V13.8C1 14.9201 1 15.4802 1.19377 15.908C1.3642 16.2843 1.63617 16.5903 1.97068 16.782C2.35097 17 2.84879 17 3.84444 17Z",
    stroke: "currentColor",
    fill: "none",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTables);
export default __webpack_public_path__ + "static/media/icon-tables.551cbc57a668d6e1ab23a0cded7a1308.svg";
export { ForwardRef as ReactComponent };